import ListItem from '@mui/material/ListItem'

import RemainingCash from './RemainingCash'

interface DetailsFooterProps {
  remaining: number
}

const DetailsFooter = ({ remaining }: DetailsFooterProps) => {
  return (
    <ListItem
      sx={{
        alignItems: 'center',
        backgroundColor: 'background.highlight',
        display: 'flex',
        gap: 12,
        padding: '12px 24px',
        borderBottomLeftRadius: '3px',
        borderBottomRightRadius: '3px',
        minHeight: 'auto',
      }}
    >
      <RemainingCash remaining={remaining} />
    </ListItem>
  )
}

export default DetailsFooter
